import { defineMessages } from "react-intl";

export const messages = defineMessages({
  label: {
    id: "button.createMessage.label",
    defaultMessage: "Send message",
    description: "Button label for create message",
  },
});
